import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, Plus } from "lucide-react";
import api from "../../lib/api";
import { AdminHeader, Btn, DataTable, Card, Input, Localized, Select } from "../../components/admin/Fields";

const empty = () => ({
  slug: "",
  title: { tr: "", en: "" },
  department: "",
  location: "",
  employment_type: "full-time",
  description: { tr: "", en: "" },
  requirements: { tr: "", en: "" },
  status: "open",
});

const AdminCareersPage = () => {
  const [rows, setRows] = useState([]);
  const [apps, setApps] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(empty());
  const [busy, setBusy] = useState(false);
  const [tab, setTab] = useState("openings");
  const load = () => {
    api.get("/admin/career-openings").then((r) => setRows(r.data));
    api.get("/admin/career-applications").then((r) => setApps(r.data));
  };
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      if (editing?.new) await api.post("/admin/career-openings", form);
      else await api.put(`/admin/career-openings/${editing.id}`, form);
      toast.success("Kaydedildi"); setEditing(null); load();
    } catch (err) { toast.error(err?.response?.data?.detail || err.message); } finally { setBusy(false); }
  };
  const remove = async (r) => {
    if (!window.confirm(`"${r.slug}" silinsin mi?`)) return;
    await api.delete(`/admin/career-openings/${r.id}`); load();
  };
  const removeApp = async (a) => {
    if (!window.confirm("Silinsin mi?")) return;
    await api.delete(`/admin/career-applications/${a.id}`); load();
  };

  if (editing) return (
    <div data-testid="admin-careers-form">
      <AdminHeader eyebrow="Careers" title={editing.new ? "Yeni İlan" : "İlanı Düzenle"}
        action={<div className="flex gap-3"><Btn variant="ghost" onClick={() => setEditing(null)}>İptal</Btn><Btn onClick={save} disabled={busy} testId="career-open-save">Kaydet</Btn></div>} />
      <form onSubmit={save} className="space-y-6">
        <Card title="İlan Bilgileri">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <Input label="Slug" value={form.slug} onChange={(v) => setForm({ ...form, slug: v })} testId="opening-slug" />
            <Input label="Departman" value={form.department} onChange={(v) => setForm({ ...form, department: v })} />
            <Input label="Konum" value={form.location} onChange={(v) => setForm({ ...form, location: v })} />
            <Select label="Tip" value={form.employment_type} onChange={(v) => setForm({ ...form, employment_type: v })} options={[{ value: "full-time", label: "Tam Zamanlı" }, { value: "part-time", label: "Yarı Zamanlı" }, { value: "contract", label: "Kontrat" }, { value: "internship", label: "Staj" }]} />
            <Select label="Durum" value={form.status} onChange={(v) => setForm({ ...form, status: v })} options={[{ value: "open", label: "Açık" }, { value: "closed", label: "Kapalı" }]} />
          </div>
          <div className="mt-6"><Localized label="Başlık" value={form.title} onChange={(v) => setForm({ ...form, title: v })} testId="opening-title" /></div>
          <div className="mt-6"><Localized label="Açıklama" value={form.description} onChange={(v) => setForm({ ...form, description: v })} textarea /></div>
          <div className="mt-6"><Localized label="Gereksinimler" value={form.requirements} onChange={(v) => setForm({ ...form, requirements: v })} textarea /></div>
        </Card>
      </form>
    </div>
  );

  return (
    <div data-testid="admin-careers-page">
      <AdminHeader
        eyebrow="Careers"
        title="Kariyer"
        action={tab === "openings" ? <Btn onClick={() => { setEditing({ new: true }); setForm(empty()); }} testId="new-opening"><Plus size={14} /> Yeni İlan</Btn> : null}
      />
      <div className="flex gap-1 border-b border-black/10 mb-6">
        {[{ k: "openings", l: "Açık İlanlar" }, { k: "applications", l: `Başvurular (${apps.length})` }].map((t) => (
          <button
            key={t.k}
            onClick={() => setTab(t.k)}
            className={`px-4 py-3 text-xs tracking-[0.22em] uppercase font-medium border-b-2 ${tab === t.k ? "border-brand-gold text-brand-navy" : "border-transparent text-brand-medium"}`}
            data-testid={`careers-tab-${t.k}`}
          >
            {t.l}
          </button>
        ))}
      </div>

      {tab === "openings" ? (
        <DataTable
          columns={[
            { key: "title", label: "Başlık", render: (r) => r.title?.tr || r.slug },
            { key: "department", label: "Departman" },
            { key: "location", label: "Konum" },
            { key: "status", label: "Durum" },
            { key: "actions", label: "", render: (r) => (
              <div className="flex justify-end gap-2">
                <Btn variant="ghost" onClick={() => { setEditing(r); setForm({ ...empty(), ...r }); }}>Düzenle</Btn>
                <Btn variant="danger" onClick={() => remove(r)}><Trash2 size={12} /></Btn>
              </div>
            ) },
          ]}
          rows={rows}
        />
      ) : (
        <DataTable
          columns={[
            { key: "name", label: "Ad" },
            { key: "email", label: "Email" },
            { key: "position", label: "Pozisyon" },
            { key: "created_at", label: "Tarih", render: (r) => (r.created_at || "").substring(0, 10) },
            { key: "actions", label: "", render: (r) => <div className="flex justify-end"><Btn variant="danger" onClick={() => removeApp(r)}><Trash2 size={12} /></Btn></div> },
          ]}
          rows={apps}
        />
      )}
    </div>
  );
};

export default AdminCareersPage;
